// AlipayJSBridgeReady是掌银App H5容器自动注入的对象
function JSBridgeReady (callback) {
  if (window.AlipayJSBridge) {
    callback && callback()
  } else {
    document.addEventListener('AlipayJSBridgeReady', callback, false)
  }
}

// 跳转页面
export function JSBridgeExec (url, closeCurrentWindow = false) {
  JSBridgeReady(function () {
    window.AlipayJSBridge.call('pushWindow', {
      url: url,
      param: {
        // 可选参数。打开新窗口的同时，关闭当前窗口
        closeCurrentWindow
      }
    })
  })
}

/**
 * 获取定位
 * @param callback
 * @return result={longitude:经度,latitude:维度,cityCode:设备城市码,province:省份,city:城市,address:具体位置}
 * @constructor
 */
export function JSBridgeLocation (callback) {
  JSBridgeReady(function () {
    window.AlipayJSBridge.call('location', {
      // 0百度定位，1高德定位（开发中）
      source: 0
    }, callback)
  })
}
